import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "asset-view-wrapper" }
const _hoisted_2 = { class: "assets-table-container" }
const _hoisted_3 = {
  key: 0,
  class: "wl-kpis"
}
const _hoisted_4 = { class: "wl-stat wl-stat--dark" }
const _hoisted_5 = { class: "wl-stat__head" }
const _hoisted_6 = { class: "wl-stat__title" }
const _hoisted_7 = { class: "wl-stat__value" }
const _hoisted_8 = { class: "wl-stat" }
const _hoisted_9 = { class: "wl-stat__head" }
const _hoisted_10 = { class: "wl-stat__title" }
const _hoisted_11 = { class: "wl-stat__value" }
const _hoisted_12 = { class: "wl-stat" }
const _hoisted_13 = { class: "wl-stat__head" }
const _hoisted_14 = { class: "wl-stat__title" }
const _hoisted_15 = { class: "wl-stat__value" }
const _hoisted_16 = { class: "wl-stat" }
const _hoisted_17 = { class: "wl-stat__head" }
const _hoisted_18 = { class: "wl-stat__title" }
const _hoisted_19 = { class: "wl-stat__value" }
const _hoisted_20 = { class: "wl-stat" }
const _hoisted_21 = { class: "wl-stat__head" }
const _hoisted_22 = { class: "wl-stat__title" }
const _hoisted_23 = { class: "wl-stat__value" }
const _hoisted_24 = { class: "wl-stat" }
const _hoisted_25 = { class: "wl-stat__head" }
const _hoisted_26 = { class: "wl-stat__title" }
const _hoisted_27 = { class: "wl-stat__value" }
const _hoisted_28 = { class: "assets-grid-card" }
const _hoisted_29 = { class: "assets-grid-card__header" }
const _hoisted_30 = { class: "assets-grid-title" }
const _hoisted_31 = { class: "assets-grid-title__text" }
const _hoisted_32 = { class: "text-muted small" }
const _hoisted_33 = { class: "assets-grid-controls" }
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "assets-grid-card__body" }
const _hoisted_36 = { class: "wl-assets-search-wrap" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = { class: "wl-assets-filters" }
const _hoisted_39 = { class: "wl-pills" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "wl-select-wrap" }
const _hoisted_42 = { value: "all" }
const _hoisted_43 = ["value"]
const _hoisted_44 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 m-3"
}
const _hoisted_45 = { class: "wp-grid-wrap" }
const _hoisted_46 = {
  key: 0,
  class: "wp-loading wp-loading--overlay"
}
const _hoisted_47 = { class: "wp-loading__text" }
const _hoisted_48 = { class: "wl-asset-name" }
const _hoisted_49 = { class: "font-monospace small" }
const _hoisted_50 = {
  key: 0,
  class: "d-flex align-items-center gap-1"
}
const _hoisted_51 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_52 = { class: "text-muted small font-monospace" }
const _hoisted_53 = {
  key: 0,
  class: "text-muted small font-monospace"
}
const _hoisted_54 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_55 = ["title"]
const _hoisted_56 = {
  class: "wl-row-actions",
  style: {"justify-content":"center"}
}
const _hoisted_57 = ["title", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('components.wirepasAssets.kpis.total')), 1),
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-collection wl-stat__icon" }, null, -1))
              ]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.kpi.total), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('components.wirepasAssets.kpis.ok')), 1),
                _cache[6] || (_cache[6] = _createElementVNode("i", {
                  class: "bi bi-tag wl-stat__icon",
                  style: {"color":"#3f8f52"}
                }, null, -1))
              ]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.kpi.ok), 1),
              _createElementVNode("div", {
                class: "wl-stat__accent",
                style: _normalizeStyle({ width: _ctx.kpi.total ? `${(_ctx.kpi.ok / _ctx.kpi.total) * 100}%` : '0%', background: '#3f8f52' })
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('components.wirepasAssets.kpis.lowBatt')), 1),
                _cache[7] || (_cache[7] = _createElementVNode("i", {
                  class: "bi bi-battery wl-stat__icon",
                  style: {"color":"#a07c20"}
                }, null, -1))
              ]),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.kpi.low_batt), 1),
              _createElementVNode("div", {
                class: "wl-stat__accent",
                style: _normalizeStyle({ width: _ctx.kpi.total ? `${(_ctx.kpi.low_batt / _ctx.kpi.total) * 100}%` : '0%', background: '#a07c20' })
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('components.wirepasAssets.kpis.dwell')), 1),
                _cache[8] || (_cache[8] = _createElementVNode("i", {
                  class: "bi bi-clock-history wl-stat__icon",
                  style: {"color":"#4870b8"}
                }, null, -1))
              ]),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.kpi.dwell), 1),
              _createElementVNode("div", {
                class: "wl-stat__accent",
                style: _normalizeStyle({ width: _ctx.kpi.total ? `${(_ctx.kpi.dwell / _ctx.kpi.total) * 100}%` : '0%', background: '#4870b8' })
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('components.wirepasAssets.kpis.transit')), 1),
                _cache[9] || (_cache[9] = _createElementVNode("i", {
                  class: "bi bi-signpost-split wl-stat__icon",
                  style: {"color":"#4870b8"}
                }, null, -1))
              ]),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.kpi.in_transit), 1),
              _createElementVNode("div", {
                class: "wl-stat__accent",
                style: _normalizeStyle({ width: _ctx.kpi.total ? `${(_ctx.kpi.in_transit / _ctx.kpi.total) * 100}%` : '0%', background: '#4870b8' })
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('components.wirepasAssets.kpis.lost')), 1),
                _cache[10] || (_cache[10] = _createElementVNode("i", {
                  class: "bi bi-exclamation-triangle wl-stat__icon",
                  style: {"color":"#e8833a"}
                }, null, -1))
              ]),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.kpi.departed), 1),
              _createElementVNode("div", {
                class: "wl-stat__accent",
                style: _normalizeStyle({ width: _ctx.kpi.total ? `${(_ctx.kpi.departed / _ctx.kpi.total) * 100}%` : '0%', background: '#e8833a' })
              }, null, 4)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
              _createElementVNode("i", { class: "bi bi-broadcast-pin" })
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('aside.menu.pages.wirepasAssets')), 1),
              _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('components.wirepasAssets.subtitle')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", {
              type: "button",
              class: "assets-toolbar-btn",
              title: _ctx.$t('components.assets.dataGrids.refresh'),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshGrid && _ctx.refreshGrid(...args)))
            }, [
              _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.refresh')), 1)
            ], 8, _hoisted_34)
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQ) = $event)),
              type: "text",
              class: "form-control wl-assets-search",
              placeholder: _ctx.$t('components.wirepasAssets.searchPlaceholder'),
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args)))
            }, null, 40, _hoisted_37), [
              [_vModelText, _ctx.searchQ]
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusFilters, (f) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: f.v,
                  type: "button",
                  class: _normalizeClass(["wl-pill", { 'wl-pill--active': _ctx.statusFilter === f.v }]),
                  onClick: ($event: any) => {_ctx.statusFilter = f.v; _ctx.refreshGrid()}
                }, _toDisplayString(f.l), 11, _hoisted_40))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_41, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.categoryFilter) = $event)),
                class: "wl-select",
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.refreshGrid()))
              }, [
                _createElementVNode("option", _hoisted_42, _toDisplayString(_ctx.$t('components.wirepasAssets.allCategories')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryLabels, (label, key) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: key,
                    value: key
                  }, _toDisplayString(label), 9, _hoisted_43))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.categoryFilter]
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-chevron-down wl-select-icon" }, null, -1))
            ])
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.error), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_45, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", {
                    class: "spinner-border wp-loading__spinner",
                    role: "status"
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t('components.wirepasAssets.loading')), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_DxDataGrid, {
              ref: "gridRef",
              class: "wirepas-assets-grid",
              "data-source": _ctx.dataSource,
              "remote-operations": true,
              "hover-state-enabled": true,
              "column-auto-width": true,
              "show-borders": false,
              "show-column-lines": false,
              "show-row-lines": false,
              "row-alternation-enabled": true,
              "column-hiding-enabled": true,
              "word-wrap-enabled": false
            }, {
              "asset-template": _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_48, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["wl-asset-dot", data.data.active ? 'wl-asset-dot--active' : 'wl-asset-dot--inactive'])
                  }, null, 2),
                  _createElementVNode("span", _hoisted_49, _toDisplayString(data.data.name || data.data.serialNumber), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["wl-category-badge", `wl-category-badge--${data.data.assetCategory}`])
                  }, _toDisplayString(_ctx.categoryLabels[data.data.assetCategory] || data.data.assetCategory), 3)
                ])
              ]),
              "location-template": _withCtx(({ data }) => [
                (data.data.location)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                      (data.data.location.type)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["wirepas-type-badge", `wirepas-type-badge--${data.data.location.type}`])
                          }, _toDisplayString(_ctx.locTypeLabel(data.data.location.type)), 3))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(data.data.location.name), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_51, "—"))
              ]),
              "lastseen-template": _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.agoText(data.data.lastSeen)), 1)
              ]),
              "since-template": _withCtx(({ data }) => [
                (data.data.sinceAtLocation)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                      _createTextVNode(_toDisplayString(_ctx.durText(data.data.sinceAtLocation)) + " ", 1),
                      (data.data.status !== 'departed')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" (" + _toDisplayString(_ctx.$t('components.wirepasAssets.ongoing')) + ")", 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_54, "—"))
              ]),
              "gw-template": _withCtx(({ data }) => [
                _createElementVNode("span", {
                  class: "text-muted small font-monospace",
                  title: data.data.gwId
                }, _toDisplayString(_ctx.shortGwId(data.data.gwId)), 9, _hoisted_55)
              ]),
              "status-template": _withCtx(({ data }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["wl-status-badge", `wl-status-badge--${data.data.status}`])
                }, _toDisplayString(_ctx.$t(`components.wirepasAssets.status.${data.data.status}`)), 3)
              ]),
              "actions-template": _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "wl-row-action",
                    title: _ctx.$t('components.wirepasAssets.showDetail'),
                    onClick: _withModifiers(($event: any) => (_ctx.$router.push(`/wirepas-assets/${data.data.id}`)), ["stop"])
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "bi bi-eye" }, null, -1)
                  ]))], 8, _hoisted_57)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_DxLoadPanel, { enabled: false }),
                _createVNode(_component_DxHeaderFilter, { visible: true }),
                _createVNode(_component_DxPaging, { "page-size": 20 }),
                _createVNode(_component_DxPager, {
                  "allowed-page-sizes": [10, 20, 50, 100],
                  "show-info": true,
                  "show-page-size-selector": true,
                  "show-navigation-buttons": true
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "serialNumber",
                  caption: _ctx.$t('components.wirepasAssets.columns.asset'),
                  flex: 3,
                  "min-width": 160,
                  "cell-template": "asset-template"
                }, null, 8, ["caption"]),
                _createVNode(_component_DxColumn, {
                  "data-field": "locationName",
                  caption: _ctx.$t('components.wirepasAssets.columns.location'),
                  flex: 2,
                  "min-width": 140,
                  "cell-template": "location-template",
                  "allow-sorting": false
                }, null, 8, ["caption"]),
                _createVNode(_component_DxColumn, {
                  "data-field": "lastSeen",
                  caption: _ctx.$t('components.wirepasAssets.columns.lastSeen'),
                  width: "140",
                  "cell-template": "lastseen-template",
                  "sort-order": "desc"
                }, null, 8, ["caption"]),
                _createVNode(_component_DxColumn, {
                  "data-field": "sinceAtLocation",
                  caption: _ctx.$t('components.wirepasAssets.columns.sinceAtLocation'),
                  width: "200",
                  "hiding-priority": 1,
                  "cell-template": "since-template",
                  "allow-sorting": false
                }, null, 8, ["caption"]),
                _createVNode(_component_DxColumn, {
                  "data-field": "gwId",
                  caption: _ctx.$t('components.wirepasAssets.columns.gateway'),
                  width: "180",
                  "hiding-priority": 2,
                  "cell-template": "gw-template"
                }, null, 8, ["caption"]),
                _createVNode(_component_DxColumn, {
                  "data-field": "status",
                  caption: _ctx.$t('components.wirepasAssets.columns.status'),
                  width: "130",
                  alignment: "center",
                  "cell-template": "status-template"
                }, null, 8, ["caption"]),
                _createVNode(_component_DxColumn, {
                  caption: "",
                  width: "56",
                  "allow-filtering": false,
                  "allow-sorting": false,
                  alignment: "center",
                  "cell-template": "actions-template"
                })
              ]),
              _: 1
            }, 8, ["data-source"])
          ])
        ])
      ])
    ])
  ]))
}